"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var NewBaggage = function NewBaggage() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "16",
    height: "20",
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M2.3077 19.5C1.80898 19.5 1.38302 19.325 1.02982 18.975C0.676608 18.625 0.5 18.207 0.5\n17.7211V6.20193C0.5 5.31346 0.783333 4.53525 1.35 3.8673C1.91667 3.19935 2.63333 2.77756 3.5\n2.60193V0.5H5.99997V2.5H9.99998V0.5H12.5V2.60193C13.3666 2.77756 14.0833 3.19935 14.65\n3.8673C15.2166 4.53525 15.5 5.31346 15.5 6.20193V17.7211C15.5 18.207 15.3233 18.625 14.9701\n18.975C14.6169 19.325 14.191 19.5 13.6922 19.5H2.3077ZM2.3077 18H13.6922C13.782 18 13.8557 17.9727\n13.9134 17.9183C13.9711 17.8638 14 17.798 14 17.7211V6.20193C14 5.59423 13.7801 5.07531 13.3404\n4.64518C12.9006 4.21504 12.3705 3.99998 11.75 3.99998H4.25C3.62948 3.99998 3.09935 4.21504 2.6596\n4.64518C2.21985 5.07531 1.99997 5.59423 1.99997 6.20193V17.7211C1.99997 17.798 2.02882 17.8638\n2.08652 17.9183C2.14423 17.9727 2.21795 18 2.3077 18ZM10.8077\n13.7884H12.3077V10.3269H3.6923V11.8269H10.8077V13.7884Z",
    fill: "#6E6D71"
  }));
};
var _default = NewBaggage;
exports.default = _default;